module.exports = __webpack_public_path__ + "static/media/At the office-pana 1.6242fc8a.png";